// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M49 47L35.5 33.6c3.1-3.5 5-8.1 5-13.1C40.5 9.5 31.6.6 20.6.6S.6 9.5.6 20.5s8.9 19.9 19.9 19.9c5 0 9.5-1.8 13-4.8L47 49c.3.3.6.4 1 .4s.7-.1 1-.4c.5-.6.5-1.4 0-2zM3.4 20.5c0-9.4 7.7-17.1 17.2-17.1s17.2 7.7 17.2 17.1c0 9.4-7.7 17.1-17.2 17.1S3.4 29.9 3.4 20.5z" />
        </svg>
    );
};

export default React.memo(Search);
